import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.UPDATE_DIMENSION.REQUEST, saga.updateDimension);
    yield takeLatest(ACTION.UPDATE_DIMENSION.SUCCESS, saga.onUpdateDimensionSuccess);
    yield takeLatest(ACTION.UPDATE_DIMENSION.FAILED, saga.onUpdateDimensionFailed);
}
